import { Cookies } from "react-cookie";
import CryptoJS from "crypto-js";

const env = process.env.REACT_APP_ENV;
const isDev = env === "developmen";

const encryptKey = `xX${env}PerForzaXx`

const CookieWrapper = () => {
  const cookies = new Cookies();

  return {
    setCookie: (data) => setCookie(data, cookies),
    removeCookie: (data) => removeCookie(data, cookies),
    readCookie: (data) => readCookie(data, cookies),
  };
};

const setCookie = (data, cookies) => {
  if (!isDev) {
    Object.keys(data).forEach(key => {
      cookies.set(key, data[key]);
    })
  } else {
    Object.keys(data).forEach(key => {
      const encrpted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        encryptKey
      ).toString();
      cookies.set(key, encrpted);
    })
  }
};

const removeCookie = (data, cookies) => {
  if (!isDev) {
    cookies.remove(data);
  }
};

const readCookie = (data, cookies) => {
  if (!isDev) {
    return cookies.get(data);
  } else {
    const tmp = cookies.get(data);
    if (tmp) {
      var bytes = CryptoJS.AES.decrypt(tmp, encryptKey);
      var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    }
  }

};

export default CookieWrapper();
